import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import {
  _setIsQualityAssuranceDataLoaded,
 // _setQualityAssuranceReviewId,
  _setReviewDate,
  _setLastReviewDate,
  _setNextReviewDate,
  _setQuestion1,
  _setQuestion2,
  _setQuestion3,
  _setQuestion4,
  _setQuestion5,
  _setQuestion6,
  _setQuestion7,
  _setQuestion8,
  _setQuestion9,
  _setQuestion10,
  _setQuestion11,
  _setQuestion13,
  _setQuestion14,
  _setQuestion15,
  _setExceptionComments,
  _setFollowUpComments,
  _setDateCreated,
  _setDateEdited,
  _setReviewCreatedBy,
  _setEditedBy,
} from './qualityAssuranceDetailAction';
import initialState from './qualityAssuranceDetailInitialState';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getQualityAssuranceDetailForm = createAsyncThunk(
  'stop/qualityAssuranceDetailForm',
  async (params) => {
    const { qualityAssuranceDetailUrl, authorization } = params;
    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .get(qualityAssuranceDetailUrl, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });

    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const qualityAssuranceDetailSlice = createSlice({
  name: 'stop/qualityAssuranceDetailSlice',
  initialState,
  reducers: {
    newQualityAssurance: (state, action) => action.payload,
    setIsQualityAssuranceDataLoaded: _setIsQualityAssuranceDataLoaded,
    //setQualityAssuranceReviewId: _setQualityAssuranceReviewId,
    setReviewDate: _setReviewDate,
    setLastReviewDate: _setLastReviewDate,
    setNextReviewDate: _setNextReviewDate,
    setQuestion1: _setQuestion1,
    setQuestion2: _setQuestion2,
    setQuestion3: _setQuestion3,
    setQuestion4: _setQuestion4,
    setQuestion5: _setQuestion5,
    setQuestion6: _setQuestion6,
    setQuestion7: _setQuestion7,
    setQuestion8: _setQuestion8,
    setQuestion9: _setQuestion9,
    setQuestion10: _setQuestion10,
    setQuestion11: _setQuestion11,
    setQuestion13: _setQuestion13,
    setQuestion14: _setQuestion14,
    setQuestion15: _setQuestion15,
    setExceptionComments: _setExceptionComments,
    setFollowUpComments: _setFollowUpComments,
    setDateCreated: _setDateCreated,
    setDateEdited: _setDateEdited,
    setReviewCreatedBy: _setReviewCreatedBy,
    setEditedBy: _setEditedBy,
  },
  extraReducers: {
    [getQualityAssuranceDetailForm.fulfilled]: (state, action) =>
      action.payload,
  },
});

export const {
  newQualityAssurance,
  setIsQualityAssuranceDataLoaded,
  //setQualityAssuranceReviewId,
  setReviewDate,
  setLastReviewDate,
  setNextReviewDate,
  setQuestion1,
  setQuestion2,
  setQuestion3,
  setQuestion4,
  setQuestion5,
  setQuestion6,
  setQuestion7,
  setQuestion8,
  setQuestion9,
  setQuestion10,
  setQuestion11,
  setQuestion13,
  setQuestion14,
  setQuestion15,
  setExceptionComments,
  setFollowUpComments,
  setDateCreated,
  setDateEdited,
  setReviewCreatedBy,
  setEditedBy,
} = qualityAssuranceDetailSlice.actions;

export default qualityAssuranceDetailSlice.reducer;
